<template>
    <component :is="currentComponent" class="dealerDashboard">
    </component>
</template>

<script>
    import PageOptions from '@/Options/PageOptions.js';

    /*
    Import all parent components to this file.
    */
    //Welcome
    import Welcome from './Welcome/Welcome'

    //Edit Profile
    import EditProfile from './Auth/EditProfile'

    //Highlight
    import DealerHighlight from './DealerDashboard/DealerHighlight/DealerHighlight'

    //DO Pending
    import DOPending from './DealerDashboard/DOPending/DOPending'

    //Tracking Unit
    import TrackingUnit from './DealerDashboard/TrackingUnit/TrackingUnit'

    //QR Code
    import DealerDistributionMonitoring from './DealerDashboard/QRCode/DistributionMonitoring/DistributionMonitoring'
    import SeDistributionMonitoring from './DealerDashboard/QRCode/DistributionMonitoring/DistributionMonitoringSe'
    import DealerBastQRMD from './DealerDashboard/QRCode/BastQRMD/BastQRMD'
    import RepeatedMapping from "./DealerDashboard/QRCode/RepeatedMapping/RepeatedMapping.vue";
    import DealerQRIssue from './DealerDashboard/QRCode/QRIssue/QRIssue.vue'
    import DealerHistory from './DealerDashboard/QRCode/History/History.vue'
    import DealerQRReceipt from './DealerDashboard/QRCode/QRReceipt/QRReceipt.vue'


    // Library
    import moment from 'moment'
    export default {
        metaInfo: {
            title: 'BI Dashboard',
            titleTemplate: '%s - QTrust',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
        components: {
            //Welcome
            Welcome,

            //Edit Profile
            EditProfile,

            //Highlight
            DealerHighlight,

            //DO Pending
            DealerDOPending:DOPending,

            //Tracking Unit
            DealerTrackingUnit:TrackingUnit,

            //QR Code
            DealerDistributionMonitoring,
            SeDistributionMonitoring,
            DealerBastQRMD,
            RepeatedMapping,
            DealerQRIssue,
            DealerHistory,
            DealerQRReceipt,
        },
        data() {
            return {
                pageOptions: PageOptions,
                currentComponent: ''
            }
        },
        created() {
            this.pageOptions.pageEmpty = false;
        },
        mounted() {
            this.currentComponent = this.$route.name
            let user = this.$store.state.userData.userData

            console.log(this.$apm)


            this.$apm.setUserContext({
                id: user.user_id,
                username: user.username
            });

            this.$apm.setCustomContext({
                access_time: new moment().format('Y-MM-DD HH:mm:ss'),
                route: this.$route.path
            })
        },
        beforeRouteLeave(to, from, next) {
            PageOptions.pageEmpty = true;
            next();
        },
        methods: {

        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@500;700&display=swap');

    .outerBox {
        padding: 0 20px;
    }

    .innerBox {
        padding: 1.5rem;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }
    
    .section--title {
        margin: 0;
        font: normal normal 500 24px/28px Ubuntu;
        color: #707070;
    }

    .chart--title {
        margin: 0;
        font: normal normal 500 18px/21px Ubuntu;
        color: #707070;
    }

    .btn-dh-download {
        box-shadow: 0px 2px 6px #00000047;
        border-radius: 5px;
        font: normal normal 500 10px/11px Ubuntu;
        background: #F36F21;
        color: white;
        height: 32px;
        width: 100%;
    }

    .btn-elegant {
        background: #FFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000014;
        border: 0.5px solid #EEE;
        padding: 0.5rem 2rem;
        font: normal normal 500 10px/11px Ubuntu;
    }

    .btn-elegant-unselected {
        background: #EEE 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000014;
        padding: 0.5rem 2rem;
        font: normal normal 500 10px/11px Ubuntu;
    }

    .ubuntu--font {
        font-family: Ubuntu;
    }

    .dh--divider {
        width: 100%;
        height: 1px;
        background-color: #F2F2F2;

        margin: 20px 0;
    }

    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__tags  {
        box-shadow: 0px 2px 6px #0000001A;
        background-color: #F36F21 !important;
        padding: 0 40px 0 12px;
        min-height: 32px;

        display: table;
        width: 100%;
    }

    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__single,
    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__input,
    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__input::placeholder,
    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__placeholder {
        background-color: #F36F21 !important;
        color: white;

        vertical-align: middle;
        padding: 0;
        font: normal normal 500 10px/11px Ubuntu;

        display: table-cell;
        vertical-align: middle;

    }

    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__select {
        height: 32px;
    }
    
    .dealerDashboard .multiselect:not(.qtrust-select) .multiselect__select:before{
        border-color: white transparent transparent;
    }

    .dealerDashboard .multiselect:not(.qtrust-select):disabled .multiselect__select {
        background-color: #FFB182
    }
</style>